if (!customElements.get('product-room-offer')) {
  class ProductRoomOffer extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('[data-room-details]');
      this.handleClick = this.handleClick.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleToggle = this.handleToggle.bind(this);

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('click', this.handleDocumentClick);
      this.details?.addEventListener('toggle', this.handleToggle);

      const trackView = () => {
        if (this.viewTracked) return;
        this.viewTracked = true;
        this.publish('view');
      };

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            trackView();
            this.observer.disconnect();
          }
        }, { threshold: 0.25 });
        this.observer.observe(this);
      } else {
        trackView();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('click', this.handleDocumentClick);
      this.details?.removeEventListener('toggle', this.handleToggle);
      this.observer?.disconnect();
    }

    handleDocumentClick(event) {
      if (this.details?.open && !this.contains(event.target)) {
        this.details.removeAttribute('open');
      }
    }

    handleKeydown(event) {
      if (event.key !== 'Escape' || !this.details?.open) return;

      this.details.removeAttribute('open');
      this.details.querySelector('summary')?.focus();
    }

    handleToggle() {
      if (!this.details?.open || this.openTracked) return;

      this.openTracked = true;
      this.publish('open');
    }

    handleClick(event) {
      const card = event.target.closest('[data-room-card]');
      if (!card || !this.contains(card)) return;
      this.publish('select', card);
    }

    publish(action, card = null) {
      const payload = {
        room_id: this.dataset.roomId || '',
        source_product_id: this.dataset.productId || '',
        source_handle: this.dataset.currentHandle || '',
        target_product_id: card?.dataset.targetProductId || '',
        target_handle: card?.dataset.targetHandle || '',
        target_price: Number(card?.dataset.targetPrice || 0),
        option_position: Number(card?.dataset.optionPosition || 0),
      };

      const eventName = `adore_room_offer_${action}`;
      window.dataLayer = window.dataLayer || [];
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName, room_offer: payload });
      }

      document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    }
  }

  customElements.define('product-room-offer', ProductRoomOffer);
}
